const API_PATH_CREATE = 'restaurant/:id/table';
const API_PATH_INDEX = 'restaurant/:id/table/';

export default {
  namespaced: true,
  state: {
    tables: {
      data: [],
      current_page: 0,
      last_page: 0,
      total: 0
    }
  },
  getters: {
    getTables: (state) => {
      return state.tables.data;
    },
    getCurrentPage: (state) => {
      return state.tables.current_page;
    },
    getLastPage: (state) => {
      return state.tables.last_page;
    },
    getTotalTables: (state) => {
      return state.tables.total
    },
    isLastPage : (state) => {
      return state.tables.last_page == state.tables.current_page;
    }
  },
  mutations: {
    resetResults: (state, payload) => {
      return new Promise(resolve => {
        state.tables.data = [];
        state.tables.current_page = 0;
        state.tables.last_page = 0;
        state.tables.total = 0;
        resolve();
      })

    },
  },
  actions: {
    saveTables(store, payload){
      return new Promise((resolve, reject) => {
        let url = API_PATH_CREATE.replace(':id', payload.restaurantId);
        let method = 'post';

        axios[method](url, payload)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    loadZones(store, payload) {
      return new Promise((resolve, reject) => {
        let nextPage = store.getters.getCurrentPage + 1;

        if (store.getters.getLastPage && nextPage > store.getters.getLastPage) {
          return resolve();
        }

        if(store.getters.isLoading){
          return resolve();
        }

        bus.$emit('onProgressLinear');
        store.state.zones.loading = true;

        let data = {};
        data.page = nextPage;
        return axios.get(API_PATH_INDEX.replace(':id', payload.restaurantId), {
          params: data,
        })
          .then(({data}) => {
            store.state.zones.data = (store.getters.getCurrentPage) ? store.getters.getZones().concat(data.data) : data.data
            store.state.zones.loading = false;
            setTimeout(() => {
              bus.$emit('offProgressLinear');
            }, 1000)
            resolve(data);
          })
      });
    },
    resetResults(store,payload){
      return new Promise((resolve,reject) => {
        store.commit('resetResults');
        resolve();
      });
    },
  }
}
